export const getMediaStream = async() => {
    
    try {
       const stream = await navigator.mediaDevices.getUserMedia({
            video: {
                width: { min: 640, ideal: 1920, max: 1920 },
                height: { min: 400, ideal: 1080 },
                frameRate: { max: 30 },
                echoCancellation: true
            },
            audio: { echoCancellation: true }
        });

        return stream;

    } catch (error) {
        console.error("Error checking media capabilities or getting media stream", error);
        throw error;
    }
}  

export const getDisplayMedia = async(options: DisplayMediaStreamOptions) => {
    try{
       const displayStream = await navigator.mediaDevices.getDisplayMedia(options);
       return displayStream;
    }catch(error){
       return null;
    }
 }

// export const getRandomColor = () => {
//     const hex = Math.floor(Math.random() * 0xFFFFFF).toString(16);
//     return `#${hex.padStart(6, '0')}`;
// }

function pad(number: Number) {
    return number.toString().padStart(2, '0');
}

const updateTimer = (startTime: number) => {
    const elapsedTime = Date.now() - startTime;

    const totalSeconds = Math.floor(elapsedTime / 1000);
    const hours = Math.floor(totalSeconds / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = totalSeconds % 60;

    return `${pad(hours)}:${pad(minutes)}:${pad(seconds)}`;
}

export const startTimer = (date: Date) => {
    const startTime = date.getMilliseconds();
    const timeInterval = setInterval(() => updateTimer(startTime), 1000);

    return timeInterval;
}



export const getUserMedia = async(options: MediaStreamConstraints) => {
    const stream = await navigator.mediaDevices.getUserMedia(options);
    return stream;
 }

 export const getRandomColor = () => {
    const hex = Math.floor(Math.random() * 0xFFFFFF).toString(16);
    return `#${hex.padStart(6, '0')}`;
 }
 
 export const getInitials = (name:string|undefined) => {
    if (!name) {
        return '';
    }
  
    // Split the name by spaces
    const nameArray = name.trim().split(' ');
  
    // Get the first letter of each word
    const initialsArray = nameArray.map(word => word[0].toUpperCase());
  
    // Join the first two letters only
    const initials = initialsArray.slice(0, 2).join('');
  
    return initials;
  };

// Utility to hash a string into a number
const hashCode = (str: string): number => {
    let hash = 0;
    for (let i = 0; i < str.length; i++) {
        const char = str.charCodeAt(i);
        hash = (hash << 5) - hash + char;
        hash |= 0; // Convert to 32-bit integer
    }
    return hash;
};

// Utility to convert a hash to a hexadecimal color
const intToRGB = (hash: number): string => {
    const color = (hash & 0x00ffffff).toString(16).toUpperCase();

    // Ensure color is 6 characters long by padding with 0s
    return "#" + "000000".substring(0, 6 - color.length) + color;
};

// Main function to get consistent color based on UUID
export const getColorFromUUID = (uuid: string): string => {
    const hash = hashCode(uuid);
    return intToRGB(hash);
};
